/**
 * Keep key and name equal
 */
export enum FeatureFlag {
  // Permanent flags for development/testing purposes
  UseStagingApi = 'UseStagingApi',
  UseMiniprofiler = 'UseMiniprofiler',
  UseEnvironmentIndicator = 'UseEnvironmentIndicator',
  // Customer-facing toggle for multi-currency mode
  NoCurrency = 'NoCurrency',
  UseSageV2 = 'UseSageV2',
}

/**
 * Only use this where you can't inject the FeatureService
 */
export function featureIsEnabled(feature: FeatureFlag) {
  return !!localStorage.getItem(feature);
}
